import React from "react"

// My Components
import { Page, Breadcrumb, Category } from "../../components"
import Genre from "../../fixtures/genre.json"
function Categories() {
  return (
    <Page title="Categories">
      <Breadcrumb>
        <Breadcrumb.List>
          <Breadcrumb.Item title="Categories" />
        </Breadcrumb.List>
      </Breadcrumb>
      <Category>
        <Category.Title>Categories</Category.Title>
        <Category.Body>
          {Genre.map((item) => {
            return <Category.Item key={item.id} to={`/genre/${item.id}/movie`} path={item.image} text={item.name} />
          })}
        </Category.Body>
      </Category>
    </Page>
  )
}

export default Categories
